/* drl-gallery.js — PDP galéria + lightbox, könyvtár nélkül. A lapozás NATÍV
 * scroll-snap; a JS leolvas (rAF), görget, nyit, variánsváltáskor előre hozza a
 * variánsképet. A rejtett diák a DOM-ban vannak; minden index a LÁTHATÓK közt. */
(function () {
  'use strict';

  function vis(c) {
    return c ? Array.prototype.filter.call(c.children, function (el) { return !el.hidden; }) : [];
  }
  function slideWidth(list) {
    return (vis(list)[0] || {}).offsetWidth || 0;
  }
  function activeIndex(list) {
    var w = slideWidth(list);
    return w ? Math.round(list.scrollLeft / w) : 0;
  }
  function scrollToIndex(list, i, behavior) {
    list.scrollTo({ left: slideWidth(list) * i, behavior: behavior || 'smooth' });
  }
  function markButtons(container, i) {
    if (!container) return;
    vis(container).forEach(function (btn, n) {
      btn.classList.toggle('is-active', n === i);
      btn.setAttribute('aria-pressed', n === i ? 'true' : 'false');
    });
  }
  function windowDots(track, i) {
    var dots = vis(track), n = dots.length, W = 7;
    if (n <= W) return;
    var start = track._start || 0;
    if (i <= start) start = Math.max(0, i - 1);
    if (i >= start + W - 1) start = Math.min(n - W, i - W + 2);
    track._start = start;
    track.style.transform = 'translateX(' + (-start * 28) + 'px)';
    dots.forEach(function (d, k) {
      d.classList.toggle('is-edge', (k === start && start > 0) || (k === start + W - 1 && start + W < n));
    });
  }
  function onScroll(list, cb) {
    var ticking = false;
    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        cb(activeIndex(list));
      });
    }, { passive: true });
  }
  function delegateButtons(container, attr, cb) {
    if (!container) return;
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('[' + attr + ']');
      if (!btn || !container.contains(btn)) return;
      cb(vis(container).indexOf(btn));
    });
  }
  class DrlGallery extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-drl-stage]');
      if (!this.list) return;
      this.dots = this.querySelector('[data-drl-dots-track]') || this.querySelector('[data-drl-dots]');
      if (this.dots) windowDots(this.dots, 0);
      this.thumbs = this.querySelector('[data-drl-thumbs]');
      this.counter = this.querySelector('[data-drl-counter]');
      this.index = 0;
      onScroll(this.list, this.sync.bind(this));
      delegateButtons(this.dots, 'data-drl-dot', this.goTo.bind(this));
      delegateButtons(this.thumbs, 'data-drl-thumb', this.goToInstant.bind(this));
      this.list.addEventListener('click', this.onStageClick.bind(this));
      this.list.addEventListener('keydown', this.onKey.bind(this));
    }
    get count() { return vis(this.list).length; }
    sync(i) {
      if (i === this.index) return;
      this.index = i;
      markButtons(this.dots, i);
      if (this.dots) windowDots(this.dots, i);
      markButtons(this.thumbs, i);
      if (this.counter) this.counter.textContent = String(i + 1);
    }
    goTo(i) {
      scrollToIndex(this.list, i, 'smooth');
      this.sync(i);
    }
    goToInstant(i) {
      scrollToIndex(this.list, i, 'instant');
      this.sync(i);
    }
    /* A saját szekciójának lightboxa: id szerint, mert a quick-add egy MÁSODIK
     * main-productot is beinjektálhat a lapra. */
    lightbox() {
      var box = document.getElementById('DrlLightbox-' + this.id.slice('DrlGallery-'.length));
      return box || (this.closest('section') || document).querySelector('drl-lightbox');
    }
    /* Variánsváltáskor hívja a product-info.js: a variánskép mindig a lista
     * elejére kerül (színpad, bélyegsor, lightbox), rejtett esetén cserével. */
    setActiveMedia(mediaId) {
      var id = String(mediaId).split('-').pop();
      var target = this.list.querySelector('[data-media-id="' + id + '"]');
      if (!target) return;
      var hidden = target.hidden;
      if (hidden || vis(this.list)[0] !== target) {
        var box = this.lightbox();
        [this.list, this.thumbs, box && box.list, box && box.thumbs].forEach(function (c) {
          if (!c) return;
          var t = c.querySelector('[data-media-id="' + id + '"]');
          if (hidden) {
            Array.prototype.forEach.call(c.querySelectorAll('[data-drl-variant-media]'), function (el) {
              el.hidden = el !== t;
            });
          }
          if (t) c.insertBefore(t, c.firstChild);
        });
        this.index = -1;
      }
      this.goToInstant(vis(this.list).indexOf(target));
    }
    onStageClick(e) {
      if (e.target.closest('a, button, deferred-media, .drl-gallery__embed')) return;
      var slide = e.target.closest('.drl-gallery__slide');
      if (!slide) return;
      var box = this.lightbox();
      /* e.detail 0 = billentyűzet: csak ilyenkor adjuk vissza a fókuszt. */
      if (box) box.open(vis(this.list).indexOf(slide), e.detail === 0 ? this.list : null);
    }
    onKey(e) {
      if (e.key === 'ArrowRight' && this.index < this.count - 1) {
        e.preventDefault();
        this.goTo(this.index + 1);
      } else if (e.key === 'ArrowLeft' && this.index > 0) {
        e.preventDefault();
        this.goTo(this.index - 1);
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var box = this.lightbox();
        if (box) box.open(this.index, this.list);
      }
    }
  }
  class DrlLightbox extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.list = this.querySelector('[data-drl-list]');
      if (!this.dialog || !this.list) return;
      this.thumbs = this.querySelector('[data-drl-thumbs]');
      this.counter = this.querySelector('[data-drl-counter]');
      this.index = 0;
      onScroll(this.list, this.sync.bind(this));
      delegateButtons(this.thumbs, 'data-drl-thumb', this.goTo.bind(this));
      var close = this.querySelector('[data-drl-close]');
      if (close) close.addEventListener('click', this.close.bind(this));
      this.dialog.addEventListener('close', this.onClose.bind(this));
      this.list.addEventListener('keydown', this.onKey.bind(this));
      this.list.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.list.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
    }
    get count() { return vis(this.list).length; }
    onKey(e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      var i = this.index + d;
      if (i < 0 || i >= this.count) return;
      e.preventDefault();
      this.goTo(i);
    }
    sync(i) {
      if (i === this.index) return;
      this.index = i;
      markButtons(this.thumbs, i);
      if (this.counter) this.counter.textContent = String(i + 1);
      var thumb = vis(this.thumbs)[i];
      if (thumb) thumb.scrollIntoView({ inline: 'center', block: 'nearest' });
    }
    goTo(i) {
      scrollToIndex(this.list, i, 'smooth');
      this.sync(i);
    }
    /* A beállás a showModal UTÁN kell: zárva a diák szélessége 0. */
    open(i, restoreTo) {
      this.restoreTo = restoreTo || null;
      this.dialog.showModal();
      this.list.focus({ preventScroll: true });
      scrollToIndex(this.list, i, 'instant');
      this.index = -1;
      this.sync(i);
    }
    close() { if (this.dialog.open) this.dialog.close(); }
    /* Záráskor a média elhallgat: a videó megáll, az iframe (YouTube, Vimeo)
     * újratöltéssel áll le — a dialog bezárása önmagában nem némítja. */
    onClose() {
      Array.prototype.forEach.call(this.list.querySelectorAll('video, iframe'), function (m) {
        if (m.pause) m.pause();
        else m.src = m.src;
      });
      if (this.restoreTo && this.restoreTo.focus) this.restoreTo.focus();
      else if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    }
    onTouchStart(e) {
      this.touch = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }
    onTouchEnd(e) {
      if (!this.touch) return;
      var t = e.changedTouches[0];
      var dy = t.clientY - this.touch.y;
      var dx = Math.abs(t.clientX - this.touch.x);
      this.touch = null;
      if (dy > 80 && dy > dx * 1.5) this.close();
    }
  }
  if (!customElements.get('drl-gallery')) customElements.define('drl-gallery', DrlGallery);
  if (!customElements.get('drl-lightbox')) customElements.define('drl-lightbox', DrlLightbox);
})();
